import styled from 'styled-components';

const CCPAStyles = styled.div`

.data-removal {
  .header-wrap {
    grid-template-columns: repeat(3, auto);
  }
}

.content {
  padding: 27px;
  text-align: center;

  ${props => props.theme.media.lg} {
    padding-top: 0px;
    margin-top: 50px;
  }

  .title {
    color: #3F5261;
    font-size: 34px;
    font-family: Poppins;
    font-weight: 600;
    line-height: 40px;
    letter-spacing: 0px;

    ${props => props.theme.media.lg} {
      font-size: 40px;
    }
  }

  .subtitle {
    p {
      color: #3F5261;
      font-size: 14px;
      font-family: Inter;
      line-height: 20px;
      letter-spacing: 0px;
      text-align: left;
      font-weight: 400;

      ${props => props.theme.media.lg} {
        max-width: 730px;
        margin: auto;
        font-size: 18px;
        line-height: 24px;
      }
    }
  }
}

.ccpa-form {
  ${props => props.theme.media.lg} {
    max-width: 592px;
    margin: auto;
    margin-top: 30px;
  }

  .form-field {
    ${props => props.theme.media.lg} {
      max-width: 400px;
      margin: auto;
    }
  }

  .additional-info {
    padding: 0 10px;
    color: #3F5261;
    font-family: Inter;
    font-size: 12px;
    line-height: 16px;
    letter-spacing: 0px;
    font-weight: 400;

    ${props => props.theme.media.lg} {
      font-size: 14px;
      line-height: 24px;
      padding: 0px;
      margin: 5px auto;
    }

    a {
      color: #3F5261;
      text-decoration: underline;
    }
  }

  .btn {
    min-width: 200px;
    border-radius: 10px;
    max-height: 45px;
  }
}

.confirmation {
  margin: 200px auto;
  text-align: center;
  padding: 0 32px;

  ${props => props.theme.media.lg} {
    margin: 226px auto 200px;
  }
  .title {
    color: #3F5261;
    font-family: Poppins;
    font-size: 26px;
    font-weight: 600;
    line-height: 38px;
    letter-spacing: 0px;

    ${props => props.theme.media.lg} {
      font-size: 34px;
    }
  }

  .subtitle {
    color: #3F5261;
    font-family: Inter;
    font-size: 18px;
    line-height: 24px;
    margin: 20px auto 30px;
    max-width: 275px;

    ${props => props.theme.media.lg} {
      max-width: 100%;
      margin-top: 10px;
      font-size: 20px;
    }
  }
}
`;

export default CCPAStyles;